/**
 * shareStepCta.js — TEST 3.15 (patient push 3a). What the chosen physician's profile sheet offers
 * while the patient is on the send conversation (ShareScreen step 'confirm-doctor').
 *
 * ★★★ THE DEFECT, MEASURED AT 6f3177ca. DoctorProfileScreen, opened from the conversation's
 *   doctor card ("View profile"), showed "Continue" — a hardcoded English string — and its
 *   handler only called onCloseProp(): it closed the sheet, exactly like the back arrow, while
 *   promising a next step. Alex, 2026-09-30, option (b): "Make it trigger the real next step of
 *   sending the case, with a label that says what happens."
 *
 * ★★ WHERE THE PENDING STEP IS READ FROM. ShareConversation owns it (`activePhase`, and
 *   `apptStep` inside the appointment group) and reports it through its `onStepChange` prop;
 *   ShareScreen keeps the last report. This function turns that report into the CTA: a locale
 *   key (en + es), its params, and what pressing it does:
 *     'send'      — the send itself; ONLY when the conversation is on its review step;
 *     'agreement' — open the agreement to sign;
 *     'show'      — close the sheet and bring the conversation's current step into view.
 *
 * Pure. scripts/check-profile-sheet-cta.mjs executes it.
 */
export function pendingStepCta(step, doctorName) {
  const phase = (step && step.activePhase) || 'intro'
  const appt = (step && step.apptStep) || 'visit-format'
  if (phase === 'review') return { key: 'shareStepCta.sendTo', params: { doctor: doctorName || '' }, action: 'send' }
  if (phase === 'agreement') return { key: 'shareStepCta.signAgreement', params: {}, action: 'agreement' }
  if (phase === 'pharmacy') return { key: 'shareStepCta.choosePharmacy', params: {}, action: 'show' }
  if (phase === 'appointment-group' && appt === 'date-time') return { key: 'shareStepCta.pickTime', params: {}, action: 'show' }
  if (phase === 'appointment-group' && appt === 'authorization') return { key: 'shareStepCta.addAuthorization', params: {}, action: 'show' }
  return { key: 'shareStepCta.chooseVisitType', params: {}, action: 'show' }
}
